import TrackingLink from '../link/tracking-link'

const Link = (props) => {
  return (
    <TrackingLink {...props} className='main-menu-link link--text'>
      {props.children}
    </TrackingLink>
  )
}

export const CategoryLink = (props) => {
  return (
    <TrackingLink {...props} className='link--text main-menu-link main-menu-link--category'>
      <span>{props.children}</span>
      <span className='text--meta'>{props.topicsCount}</span>
    </TrackingLink>
  )
}

export default Link
